import { render, staticRenderFns } from "./SaldoTable.vue?vue&type=template&id=24d982a8&"
import script from "./SaldoTable.vue?vue&type=script&lang=js&"
export * from "./SaldoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports